// src/reducers/blogReducer.js
import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
  SAVE_BLOG_REQUEST,
  SAVE_BLOG_SUCCESS,
  SAVE_BLOG_FAILURE,
  DELETE_BLOG_REQUEST,
  DELETE_BLOG_SUCCESS,
  DELETE_BLOG_FAILURE,
} from "../actions/types";

const initialState = {
  blogs: [],
  loading: false,
  saving: false,
  error: null,
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BLOGS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_BLOGS_SUCCESS:
      return { ...state, loading: false, blogs: action.payload };

    case FETCH_BLOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SAVE_BLOG_REQUEST:
      return { ...state, saving: true, error: null };

    case SAVE_BLOG_SUCCESS:
      return { ...state, saving: false };

    case SAVE_BLOG_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case DELETE_BLOG_REQUEST:
      return { ...state, saving: true, error: null };

    case DELETE_BLOG_SUCCESS:
      return { ...state, saving: false };

    case DELETE_BLOG_FAILURE:
      return { ...state, saving: false, error: action.payload };

    default:
      return state;
  }
};

export default blogReducer;
